import Axios from "axios";
import { BaseService } from "./BaseService";
import { Perfil, PerfilTarea } from "@/model/Perfil";
import { Menu } from "@/model/Menu";

BaseService.loadAxios();

const RESOURCE_NAME = "/perfil";

export class PerfilService {
    public static async getPerfisAsync() {        
        return await Axios.get(RESOURCE_NAME);
    }

    public static async grabarperfilAsync(perfil: Perfil) {
        return await Axios.post(RESOURCE_NAME, perfil);
    }

    public static async actualizarperfilAsync(perfil: Perfil) {
        return await Axios.put(RESOURCE_NAME, perfil);
    }

    public static async quitarperfil(id: string) {
        return await Axios.delete(`${RESOURCE_NAME}/${id}`);
    }
   
    public static async getMenuAsignarAsync(id: string) {
        return await Axios.get(`${RESOURCE_NAME}/${id}/asignar`);
    }

    public static async getMenusAsync(id: string) {
        return await Axios.get(`${RESOURCE_NAME}/menu/${id}`);
    }
        
    public static async grabarMenusPerfilAsync(menus: Menu) {
        return await Axios.post(RESOURCE_NAME + '/menus', menus);
    }
    
    public static async asignarTareasAsync(item: PerfilTarea){
        return await Axios.post(RESOURCE_NAME + "/asignar/tareas", item);
    }
    
}